module.exports = __webpack_public_path__ + "static/assets/506bfb72e97b2a0b5d0a2ec92fb7732f.svg";